// ============================================================================
// CHINESE TRANSLATIONS - CHAPTER 6: 保罗的宣教之旅
// ============================================================================
// 关卡 66-78（13个关卡，39个问题）

export const chapter6Translations = {
  name: "保罗的宣教之旅",
  description: "直到地极...",
  
  spiritualWisdom: {
    principle: "福音是给万国的，必须向全世界宣告",
    scripture: "你们要去，使万民作我的门徒（马太福音28:19）",
    application: "每个基督徒都蒙召在神安置他的地方为基督作见证"
  },
  
  levels: {
    66: {
      name: "第一次宣教旅行",
      challenge: "要为我分派巴拿巴和扫罗，去做我召他们所做的工...",
      easy: {
        question: "谁陪伴保罗第一次旅行？",
        options: ["彼得", "巴拿巴", "西拉", "提摩太"],
        hint: "'劝慰子'",
        funFact: "👥 巴拿巴在保罗归主后接纳了他 - 神圣的伙伴关系！"
      },
      medium: {
        question: "他们从哪个城市出发宣教？",
        options: [
          "耶路撒冷",
          "叙利亚的安提阿",
          "大数",
          "大马士革"
        ],
        hint: "第一个犹太人和外邦人混合的教会",
        funFact: "🚢 安提阿：西方世界福音化的出发港！"
      },
      hard: {
        question: "这第一次旅行揭示了什么宣教策略？",
        options: [
          "必须留在自己的地区",
          "福音超越所有文化界限",
          "只有犹太人能得救",
          "宣教是可选的"
        ],
        hint: "这关乎信息的普世性",
        funFact: "🌊 横渡地中海 = 迈向世界福音化的一步！"
      }
    },
    
    67: {
      name: "在塞浦路斯遇到以吕马",
      challenge: "你这充满各样诡诈奸恶，魔鬼的儿子...",
      easy: {
        question: "哪个术士在塞浦路斯反对保罗？",
        options: ["西门", "以吕马", "亚波罗", "亚历山大"],
        hint: "一个想使方伯转离的假先知",
        funFact: "🪄 福音与魔术的首次直接对抗！"
      },
      medium: {
        question: "保罗对以吕马做了什么惩罚？",
        options: [
          "赶走了他",
          "使他暂时失明",
          "忽视了他",
          "与他辩论"
        ],
        hint: "暂时的失明，为要打开他属灵的眼睛",
        funFact: "👁️ 神圣的讽刺：那个使人心灵盲目的人暂时失明了！"
      },
      hard: {
        question: "这个插曲如何说明福音的能力？",
        options: [
          "暴力是必要的",
          "神的真理战胜谎言",
          "必须与所有术士争战",
          "保罗有报复心"
        ],
        hint: "这关乎神的权柄面对欺骗",
        funFact: "⚡ 方伯看见神的大能就信了 - 有效的见证！"
      }
    },

    68: {
      name: "在彼西底的安提阿",
      challenge: "神的道先讲给你们，原是应当的...",
      easy: {
        question: "保罗到一个城市首先在哪里传道？",
        options: [
          "在公共广场",
          "首先在会堂",
          "在富人家",
          "在异教庙宇"
        ],
        hint: "他总是从自己的百姓开始",
        funFact: "🕍 宣教策略：先向犹太人，后向外邦人！"
      },
      medium: {
        question: "犹太人如何回应保罗的信息？",
        options: [
          "所有人都接受了",
          "分裂了：一些人相信，另一些人反对",
          "保持冷漠",
          "立即驱逐他"
        ],
        hint: "面对福音的典型分裂",
        funFact: "⚖️ 福音总是分裂：接受或拒绝，没有冷漠！"
      },
      hard: {
        question: "保罗为什么转向外邦人？",
        options: [
          "他更喜欢外邦人",
          "犹太人的拒绝为外邦人打开了门",
          "这更容易",
          "他放弃了使命"
        ],
        hint: "这关乎预言的应验",
        funFact: "🚪 '外邦人的光' - 以赛亚的预言被保罗应验！"
      }
    },

    69: {
      name: "在路司得医治",
      challenge: "有神藉着人形降临在我们中间了！",
      easy: {
        question: "保罗在路司得治好了什么？",
        options: [
          "瞎子",
          "生来瘸腿的",
          "聋哑人",
          "麻风病人"
        ],
        hint: "一个从未走过路的人",
        funFact: "🦵 壮观的神迹：'你起来，两脚站直！' - 医治的信心！"
      },
      medium: {
        question: "众人把保罗和巴拿巴当作谁？",
        options: [
          "国王",
          "神（丢斯和希耳米）",
          "术士",
          "先知"
        ],
        hint: "希腊万神殿的神祇",
        funFact: "⚡ 巴拿巴 = 丢斯（威严），保罗 = 希耳米（演说家）- 文化误解！"
      },
      hard: {
        question: "保罗如何回应这种偶像崇拜？",
        options: [
          "接受荣誉",
          "撕裂衣裳并传讲真神",
          "出于礼貌保持沉默",
          "利用这个情况"
        ],
        hint: "完全拒绝偶像崇拜",
        funFact: "👔 撕裂衣裳 = 犹太人对偶像崇拜的恐惧 - 完全的诚实！"
      }
    },

    70: {
      name: "石击和复活",
      challenge: "门徒正围着他，他就起来，走进城去...",
      easy: {
        question: "路司得的居民对保罗做了什么？",
        options: [
          "监禁他",
          "用石头打他",
          "放逐他",
          "钉他十字架"
        ],
        hint: "传统的犹太刑罚",
        funFact: "🪨 一天之内从'神'到'死' - 人群的善变！"
      },
      medium: {
        question: "保罗被石头打后做了什么？",
        options: [
          "逃离城市",
          "躲藏起来",
          "起来并回到城里",
          "去医院"
        ],
        hint: "在被认为死后的超自然勇气",
        funFact: "💪 神迹般的复活或神的医治 - 难以置信的勇气！"
      },
      hard: {
        question: "这次逼迫揭示了见证的代价是什么？",
        options: [
          "必须避免冲突",
          "为基督作见证可能付出生命代价",
          "保罗不谨慎",
          "逼迫是无用的"
        ],
        hint: "这关乎真实见证的代价",
        funFact: "✝️ '我们进入神的国，必须经历许多艰难' - 保罗的现实主义！"
      }
    },

    71: {
      name: "耶路撒冷会议",
      challenge: "你们若不按摩西的规条受割礼，不能得救...",
      easy: {
        question: "耶路撒冷会议上有什么重要辩论？",
        options: [
          "洗礼",
          "归信的外邦人的割礼",
          "安息日",
          "奉献"
        ],
        hint: "必须成为犹太人才能成为基督徒吗？",
        funFact: "✂️ 第一次重大危机：基督教还是犹太基督教？"
      },
      medium: {
        question: "会议的最终决定是什么？",
        options: [
          "强制割礼",
          "外邦人自由，但有一些建议",
          "与犹太人完全分离",
          "推迟决定"
        ],
        hint: "向外邦人开放，没有主要限制",
        funFact: "🆓 历史性革命：福音脱离摩西律法！"
      },
      hard: {
        question: "这次会议对普世教会有什么重要性？",
        options: [
          "次要事件",
          "确立了仅凭信心得救的普世性",
          "分裂教会",
          "加强律法主义"
        ],
        hint: "这关乎普世教会的基础",
        funFact: "🌍 没有这个决定，基督教可能仍是犹太教的一个派别！"
      }
    },

    72: {
      name: "第二次旅行：提摩太",
      challenge: "保罗要带他同去，就因那些地方的犹太人，给他行了割礼...",
      easy: {
        question: "谁作为年轻同工加入保罗？",
        options: ["马可", "路加", "提摩太", "提多"],
        hint: "保罗的'亲爱的儿子'",
        funFact: "👦 提摩太：年轻奇才成为保罗的得力助手 - 成功的门徒培养！"
      },
      medium: {
        question: "尽管获得了自由，保罗为什么还给提摩太行割礼？",
        options: [
          "法律义务",
          "在犹太人中的宣教策略",
          "传统",
          "错误"
        ],
        hint: "避免障碍的实际智慧",
        funFact: "🎯 有智慧的自由：'向什么样的人，我就作什么样的人，为要得着些人'！"
      },
      hard: {
        question: "这种态度如何说明宣教的灵活性？",
        options: [
          "保罗反复无常",
          "他调整方法而不妥协福音",
          "他屈服于压力",
          "他虚伪"
        ],
        hint: "这关乎处境化的智慧",
        funFact: "⚖️ 坚定的原则，灵活的方法 - 有效见证的艺术！"
      }
    },

    73: {
      name: "马其顿人的异象",
      challenge: "请你过到马其顿来帮助我们！",
      easy: {
        question: "保罗在夜间异象中看到了什么？",
        options: [
          "天使",
          "一个马其顿人在呼唤他",
          "耶稣对他说话",
          "大光"
        ],
        hint: "来自欧洲的求助呼声",
        funFact: "🌉 决定性的异象：福音传到欧洲 - 历史性转折！"
      },
      medium: {
        question: "第一个被福音化的欧洲城市是哪个？",
        options: [
          "雅典",
          "哥林多",
          "腓立比",
          "帖撒罗尼迦"
        ],
        hint: "马其顿的罗马殖民地",
        funFact: "🏛️ 腓立比：第一个欧洲教会 - 大陆永远改变了！"
      },
      hard: {
        question: "这个异象对基督教历史象征着什么？",
        options: [
          "普通的梦",
          "神意安排的西进扩张",
          "幻觉",
          "计划改变"
        ],
        hint: "这关乎神的旨意引导历史",
        funFact: "🗺️ 没有这个异象，欧洲可能仍是异教 - 神的计划！"
      }
    },

    74: {
      name: "吕底亚，第一位欧洲归信者",
      challenge: "主就开导吕底亚的心，叫她留心听...",
      easy: {
        question: "吕底亚的职业是什么？",
        options: [
          "面包师",
          "卖紫色布疋的",
          "织工",
          "陶工"
        ],
        hint: "当时的奢侈品贸易",
        funFact: "🟣 紫色 = 非常昂贵的皇家颜色 - 吕底亚很富裕！"
      },
      medium: {
        question: "保罗在哪里遇到吕底亚？",
        options: [
          "在市场",
          "在河边祷告的地方",
          "在她家",
          "在会堂"
        ],
        hint: "露天祷告场所",
        funFact: "🏞️ 腓立比没有会堂 - 按传统在水边祷告！"
      },
      hard: {
        question: "吕底亚的归信揭示了神的工作是什么？",
        options: [
          "她有倾向",
          "神打开准备好接受祂话语的心",
          "这是巧合",
          "保罗有说服力"
        ],
        hint: "这关乎神在归信中的作为",
        funFact: "💝 '主就开导她的心' - 神预备并打开心灵！"
      }
    },

    75: {
      name: "在腓立比坐监",
      challenge: "约在半夜，保罗和西拉祷告唱诗赞美神...",
      easy: {
        question: "保罗和西拉为什么被监禁？",
        options: [
          "偷窃",
          "赶鬼扰乱公共秩序",
          "亵渎",
          "暴乱"
        ],
        hint: "医治一个使女占卜的",
        funFact: "💸 释放一个灵魂让剥削者付出代价 - 经济迫害！"
      },
      medium: {
        question: "保罗和西拉在监狱里做了什么？",
        options: [
          "抱怨",
          "祷告唱诗",
          "准备辩护",
          "睡觉"
        ],
        hint: "尽管被锁链捆绑仍然赞美",
        funFact: "🎵 半夜在监狱里唱赞美诗 - 令人印象深刻的坚定信心！"
      },
      hard: {
        question: "他们的态度如何改变了局面？",
        options: [
          "没有效果",
          "地震后禁卒归信",
          "激怒了看守",
          "使他们发疯"
        ],
        hint: "榜样的有力见证",
        funFact: "🌍 地震 + 见证 = 禁卒和全家归信！"
      }
    },

    76: {
      name: "在雅典：亚略巴古",
      challenge: "你们所不认识而敬拜的，我现在告诉你们...",
      easy: {
        question: "保罗在雅典提到了什么祭坛？",
        options: [
          "宙斯神",
          "未识之神",
          "阿波罗",
          "雅典娜"
        ],
        hint: "一个神秘的铭文作为起点",
        funFact: "🏛️ '未识之神' - 与希腊哲学巧妙的接触点！"
      },
      medium: {
        question: "保罗在雅典向谁讲道？",
        options: [
          "普通群众",
          "在亚略巴古的伊壁鸠鲁和斯多亚派哲学家",
          "庙宇的祭司",
          "罗马皇帝"
        ],
        hint: "希腊知识精英",
        funFact: "🧠 亚略巴古 = 古代哈佛 - 保罗面对最伟大的思想家！"
      },
      hard: {
        question: "雅典人对复活有什么反应？",
        options: [
          "一致接受",
          "分裂：有人讥诮，有人感兴趣",
          "普遍愤怒",
          "完全冷漠"
        ],
        hint: "知识分子对这个奥秘的典型反应",
        funFact: "🤔 复活 = 骄傲人类智慧的绊脚石！"
      }
    },

    77: {
      name: "哥林多：制帐棚的保罗",
      challenge: "他就和他们同住做工，他们本是制造帐棚为业...",
      easy: {
        question: "保罗靠什么手艺谋生？",
        options: [
          "渔夫",
          "制造帐棚",
          "文士",
          "商人"
        ],
        hint: "他学过的手工艺",
        funFact: "⛺ 保罗：使徒-工匠 - 基督徒中手工劳动的尊严！"
      },
      medium: {
        question: "保罗在哥林多住在谁家？",
        options: [
          "在客栈",
          "在亚居拉和百基拉家",
          "在总督家",
          "在会堂"
        ],
        hint: "一对像他一样的制帐棚夫妇",
        funFact: "👫 亚居拉和百基拉：模范宣教夫妇 - 基督徒的款待！"
      },
      hard: {
        question: "保罗为什么亲手做工？",
        options: [
          "仅仅因为经济需要",
          "为了不成为负担并证实他的见证",
          "因为家族传统",
          "因为他喜欢这个职业"
        ],
        hint: "这关乎独立性和可信度",
        funFact: "💼 经济自主 = 言论自由 - 保罗不依赖任何人！"
      }
    },

    78: {
      name: "以弗所的骚乱",
      challenge: "大哉，以弗所人的亚底米啊！",
      easy: {
        question: "谁在以弗所煽动反对保罗的骚乱？",
        options: [
          "罗马当局",
          "银匠底米丢和工匠",
          "哲学家",
          "犹太祭司"
        ],
        hint: "制造亚底米神龛的人",
        funFact: "🏛️ 历史上第一次罢工：福音威胁偶像经济！"
      },
      medium: {
        question: "保罗在以弗所教导了多长时间？",
        options: [
          "6个月",
          "1年",
          "2年",
          "3年"
        ],
        hint: "他最长的宣教停留",
        funFact: "📅 3年密集教导 - 以弗所成为重要的宣教中心！"
      },
      hard: {
        question: "这次骚乱揭示了福音的社会影响是什么？",
        options: [
          "福音不改变任何东西",
          "它改变经济和社会结构",
          "只涉及宗教",
          "它避免冲突"
        ],
        hint: "这关乎深刻的社会转变",
        funFact: "💰 当福音推进时，偶像失去市场 - 经济影响！"
      }
    }
  }
};

export default chapter6Translations;
